<template>
  <v-snackbar v-model="snackbar" :color="success? 'success':'error'" top :timeout="900000" dark>
    <v-icon color="white" class="mr-3">{{success? 'mdi-check':'mdi-close'}}</v-icon>
    <div>
      <span v-html="message"></span>
    </div>
    <v-btn icon @click="close">
      <v-icon>mdi-close-circle</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["snackbar", "message", "error", "success"],
  methods: {
    ...mapActions(["clearSnackAlert"]),
    close() {
      this.clearSnackAlert();
    }
  }
};
</script>
